export function getScreenSize(width: number): string {
  if (width > 0 && width < 400) return "xs";
  else if (width > 400 && width < 600) return "sm";
   
    else if (width > 600 && width < 1000) return "md";
    else if (width > 1000 && width < 1200) return "lg";
    else if (width > 1200 && width < 1900) return "xl";
    else return "xxl";
  }
  
  export function getTitleSize(screen_size: string): "h5" | "h6" {
    switch (screen_size) {
      case "xs":
        return "h6";
      case "sm":
      case "md":
        return "h6";
      case "lg":
      case "xl":
        return "h5";
      default:
        return "h5";
    }
  }
  
  export function getStepperOrientation(screen_size: string): "vertical" | "horizontal" {
    switch (screen_size) {
      case "xs":
      case "sm":
        return "vertical";
      case "md":
      case "lg":
      case "xl":
        return "horizontal";
      default:
        return "horizontal";
    }
  }
  
  export function getScale(size: string): number {
    switch (size) {
      case "sm":
        return 0.7;
      case "xs":
        return 0.65;
      case "md":
        return 1.3;
      case "xl":
        return 1.7;
      default:
        return 2;
    }
  }
  
  export function getIconSize(size: string): string {
    switch (size) {
      case "xs":
        return "18%";
      case "sm":
        return "35%";
      case "md":
        return "35%";
      case "lg":
        return "35%";
      case "xl":
        return "65%";
      case "xxl":
        return "65%";
      default:
        return "65%";
    }
  }
  export function getMenuIconSize(size: string): number {
    switch (size) {
      case "xs":
        return 15;
      case "sm":
        return 30;
  
      case "md":
        return 30;
  
      case "lg":
        return 30;
  
      case "xl":
        return 30;
  
      case "xxl":
        return 40;
  
      default:
        return 30;
    }
  }